<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Перезагрузить</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="rebootModel" max-width="400">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Перезагрузка</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="rebootModel = false"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              @click="reboot"
              :loading="isloading"
            >
              Выполнить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="issetRightDoorphones()">
              <h3>Успешно перезагружены домофоны:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.right_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}
                </li>
              </ul>
            </v-col>
            <v-col v-if="issetFailDoorphones()">
              <h3>Не удалось перезагрузить домофоны:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.fail_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }} - {{ doorphone.error }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Reboot',
  props: ['doorphones'],
  data () {
    return {
      rebootModel: false,
      dialogResult: false,
      isloading: false,
      updateResult: {},
    };
  },
  methods: {
    ...mapActions({
      massRebootDoorphone: 'Doorphone/massRebootDoorphone',
    }),
    reboot () {
      const selectedDoorphoneId = this.doorphones.map(doorphone => { return doorphone.id; });
      this.isloading = true;
      this.massRebootDoorphone({
        doorphones: selectedDoorphoneId,
      })
        .then((res) => {
          this.updateResult = res;
          this.dialogResult = true;
        })
        .catch((error) => {
          this.$flash_warning('Не удалось сделать перезагрузку.');
          console.error(error);
        })
        .finally(() => {
          this.isloading = false;
        });
    },
    issetRightDoorphones () {
      return this.updateResult.right_doorphones && this.updateResult.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.updateResult.fail_doorphones && this.updateResult.fail_doorphones.length > 0;
    },
  },
};
</script>

<style scoped>

</style>
